import React, { useEffect } from "react";

const BitrixForm = () => {
  useEffect(() => {
    // Создаём скрипт формы Bitrix24
    const script = document.createElement("script");
    script.dataset.b24Form = "inline/2501/j5df9k";
    script.dataset.skipMoving = "true";
    script.async = true;
    script.textContent = `(function(w,d,u){var s=d.createElement('script');s.async=true;s.src=u+'?'+(Date.now()/180000|0);var h=d.getElementsByTagName('script')[0];h.parentNode.insertBefore(s,h);})(window,document,'https://cdn-ru.bitrix24.ru/b8657289/crm/form/loader_2501.js');`;

    const container = document.getElementById("b24-form-container");
    if (container) {
      container.appendChild(script);
    }

    // Очистка при размонтировании (удаляем скрипт)
    return () => {
      const scripts = document.querySelectorAll(
        'script[data-b24-form="inline/2501/j5df9k"]',
      );
      scripts.forEach((s) => s.remove());
      const containerDiv = document.getElementById("b24-form-container");
      if (containerDiv) containerDiv.innerHTML = "";
    };
  }, []);

  return <div id="b24-form-container"></div>;
};

export default BitrixForm;
